import React from 'react';
import { PropertyGrid, Checkbox, TextInput, Pane } from '@leverege/ui-elements';
import { ns } from '@leverege/i18n';
import PieChartModel from "../models/PieChartModel.js";
const {
  t
} = ns('ui-attributes-graphs.editors.RolloverEditor');
export default function PieRolloverEditor(props) {
  const {
    value,
    onChange
  } = props;
  return /*#__PURE__*/React.createElement(Pane, {
    variant: "xyChartEditor|editor"
  }, /*#__PURE__*/React.createElement(PropertyGrid, {
    variant: "xyChartEditor|editor"
  }, /*#__PURE__*/React.createElement(PropertyGrid.Header, {
    title: t('rollover')
  }), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    fillcell: true,
    label: /*#__PURE__*/React.createElement(Checkbox, {
      label: t('visible'),
      value: PieChartModel.getRolloverVisible(value),
      eventData: "setRolloverVisible",
      onChange: onChange
    })
  }), /*#__PURE__*/React.createElement(PropertyGrid.Divider, null), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    fillcell: true,
    label: /*#__PURE__*/React.createElement(Checkbox, {
      label: t('rolloverLabelVisible'),
      value: PieChartModel.getRolloverLabelVisible(value),
      eventData: "setRolloverLabelVisible",
      onChange: onChange
    })
  }), /*#__PURE__*/React.createElement(PropertyGrid.Divider, null), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    fillcell: true,
    label: /*#__PURE__*/React.createElement(Checkbox, {
      label: t('rolloverCountVisible'),
      value: PieChartModel.getRolloverCountVisible(value),
      eventData: "setRolloverCountVisible",
      onChange: onChange
    })
  }), /*#__PURE__*/React.createElement(PropertyGrid.Divider, null), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    fillcell: true,
    label: /*#__PURE__*/React.createElement(Checkbox, {
      label: t('rolloverPercentVisible'),
      value: PieChartModel.getRolloverPercentVisible(value),
      eventData: "setRolloverPercentVisible",
      onChange: onChange
    })
  }), /*#__PURE__*/React.createElement(PropertyGrid.Divider, null), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('rolloverPaneVariant')
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: PieChartModel.getRolloverPaneVariant(value),
    eventData: "setRolloverPaneVariant",
    onChange: onChange,
    hint: t('rolloverPaneVariantHint')
  }))), /*#__PURE__*/React.createElement(PropertyGrid, {
    variant: "xyChartEditor|editor"
  }, /*#__PURE__*/React.createElement(PropertyGrid.Header, {
    title: t('label')
  }), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('rolloverLabelFlexVariant')
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: PieChartModel.getRolloverLabelFlexVariant(value),
    eventData: "setRolloverLabelFlexVariant",
    onChange: onChange,
    hint: t('rolloverLabelFlexVariantHint')
  })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('rolloverLabelTextVariant')
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: PieChartModel.getRolloverLabelTextVariant(value),
    eventData: "setRolloverLabelTextVariant",
    onChange: onChange,
    hint: t('rolloverLabelTextVariantHint')
  }))), /*#__PURE__*/React.createElement(PropertyGrid, {
    columns: 2,
    variant: "xyChartEditor|editor",
    inline: true
  }, /*#__PURE__*/React.createElement(PropertyGrid.Header, {
    title: t('count')
  }), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('rolloverCountFlexVariant')
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: PieChartModel.getRolloverCountFlexVariant(value),
    eventData: "setRolloverCountFlexVariant",
    onChange: onChange,
    hint: t('rolloverCountFlexVariantHint')
  })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('rolloverCountTextVariant')
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: PieChartModel.getRolloverCountTextVariant(value),
    eventData: "setRolloverCountTextVariant",
    onChange: onChange,
    hint: t('rolloverCountTextVariantHint')
  })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('rolloverCountValueVariant')
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: PieChartModel.getRolloverCountValueVariant(value),
    eventData: "setRolloverCountValueVariant",
    onChange: onChange,
    hint: t('rolloverCountValueVariantHint')
  }))), /*#__PURE__*/React.createElement(PropertyGrid, {
    columns: 2,
    variant: "xyChartEditor|editor",
    inline: true
  }, /*#__PURE__*/React.createElement(PropertyGrid.Header, {
    title: t('percent')
  }), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('rolloverPercentFlexVariant')
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: PieChartModel.getRolloverPercentFlexVariant(value),
    eventData: "setRolloverPercentFlexVariant",
    onChange: onChange,
    hint: t('rolloverPercentFlexVariantHint')
  })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('rolloverPercentTextVariant')
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: PieChartModel.getRolloverPercentTextVariant(value),
    eventData: "setRolloverPercentTextVariant",
    onChange: onChange,
    hint: t('rolloverPercentTextVariantHint')
  })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('rolloverPercentValueVariant')
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: PieChartModel.getRolloverPercentValueVariant(value),
    eventData: "setRolloverPercentValueVariant",
    onChange: onChange,
    hint: t('rolloverPercentValueVariantHint')
  }))));
}